<template>
  <div>
    <NavigationBar titel="Details" showBackBtn></NavigationBar>
    <v-snackbar v-model="snackbar.model" timeout="5000"
      >{{ snackbar.text }}.</v-snackbar
    >
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-badge-account-horizontal-outline"
                title="Benutzerdaten"
              ></Subheader>
              <div class="mt-7">
                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-avatar
                        size="56"
                        color="secondary"
                        class="mr-5"
                        rounded
                      >
                        <span class="white--text">{{
                          initialien(data.user.displayName)
                        }}</span>
                      </v-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="title">{{
                          data.user.displayName
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ data.user.email }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-chip
                        :color="
                          data.access.status === 'activated'
                            ? 'green lighten-4'
                            : 'red lighten-4'
                        "
                        label
                        :class="
                          data.access.status === 'activated'
                            ? 'font-weight-medium green--text text--darken-4'
                            : 'font-weight-medium red--text text--darken-4'
                        "
                        >{{ textFromUserStatus(data.access.status) }}</v-chip
                      >
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left>mdi-shield-account-outline</v-icon>
                          Benutzergruppe
                        </div>
                        <div class="text-body-1 font-weight-medium">
                          {{ data.group.title }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="data.division">
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left
                            >mdi-office-building-outline</v-icon
                          >
                          Abteilung
                        </div>
                        <div class="text-body-1 font-weight-medium">
                          {{ data.division.title }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="data.license">
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left>mdi-key-variant</v-icon>
                          Lizenz
                        </div>
                        <div class="text-body-1 font-weight-medium">
                          {{ data.license.title }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left>mdi-identifier</v-icon>
                          Benutzer-ID
                        </div>
                        <div
                          class="text-body-2 text-truncate"
                          style="max-width: 200px"
                        >
                          <pre>{{ data.user.uid }}</pre>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left>mdi-account-clock-outline</v-icon>
                          Zugriffstyp
                        </div>
                        <div class="text-body-1">
                          {{ data.access.type || "Standard" }}
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-if="
                          data.access.featureFlags &&
                          data.access.featureFlags.length > 0
                        "
                      >
                        <div class="text-caption text--secondary mb-1">
                          <v-icon small left>mdi-flag-outline</v-icon>
                          Feature Flags
                        </div>
                        <div>
                          <v-chip
                            v-for="flag in data.access.featureFlags"
                            :key="flag"
                            x-small
                            class="mr-1 mt-1"
                          >
                            {{ flag }}
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="data.access.status !== 'archived'">
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-shield-account"
                title="Berechtigungen"
              ></Subheader>

              <!-- Permission Tree View -->
              <div class="mt-7">
                <v-card>
                  <v-card-text>
                    <PermissionTreeView
                      :selected-permissions="allPermissions"
                      :group-permissions="groupPermissions"
                      :role-permissions="rolePermissions"
                      :individual-permissions="individualPermissions"
                      readOnly
                      showSearch
                      showSummary
                      showPermissionSource
                    />
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
            <v-col cols="12">
              <Subheader icon="mdi-security" title="Rollen"></Subheader>
              <div class="mt-7">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <div class="text-body-1 mb-4">
                            Die Berechtigungen eines Benutzers werden durch die
                            Benutzerrolle bestimmt, die ihm zugewiesen wurde.
                            Zusätzliche Rollen können individuell zugewiesen
                            werden.
                          </div>
                        </v-col>

                        <v-col cols="12">
                          <v-card outlined>
                            <v-card-subtitle class="pb-2">
                              <v-icon small left
                                >mdi-shield-check-outline</v-icon
                              >
                              Zugewiesene Rollen aus Benutzergruppe
                            </v-card-subtitle>
                            <v-card-text>
                              <v-chip
                                v-for="(item, index) in filteredGroupRolesIds"
                                :key="index"
                                label
                                class="mt-2 mr-2"
                                >{{ getRoleTitle(item) }}</v-chip
                              >
                              <div
                                v-if="
                                  !data.access.roles.groupRolesIds ||
                                  data.access.roles.groupRolesIds.length === 0
                                "
                                class="text-caption text--secondary"
                              >
                                Keine Rollen aus Benutzergruppe zugewiesen
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>

                        <v-col cols="12">
                          <v-card outlined>
                            <v-card-subtitle class="pb-2">
                              <v-icon small left
                                >mdi-account-star-outline</v-icon
                              >
                              Zugewiesene individuelle Rollen
                            </v-card-subtitle>
                            <v-card-text>
                              <v-autocomplete
                                v-model="data.access.roles.individualRolesIds"
                                :items="roles"
                                item-text="title"
                                item-value="meta.id"
                                item-disabled="meta.disabled"
                                clearable
                                outlined
                                chips
                                multiple
                                small-chips
                                deletable-chips
                                label="Rollen auswählen"
                                class="mt-4"
                              ></v-autocomplete>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions class="mr-5 mb-2">
                    <v-spacer></v-spacer>
                    <v-btn depressed color="primary" @click="updateRole()">
                      <v-icon left>mdi-content-save</v-icon>
                      Änderungen speichern
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="data.access.status !== 'archived'">
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-dots-horizontal"
                title="Aktionen"
              ></Subheader>
              <div class="mt-7">
                <v-card>
                  <v-card-title>
                    <div class="d-flex align-center">
                      <v-icon left color="warning">mdi-shield-lock</v-icon>
                      <div class="subtitle-1 font-weight-medium">
                        Zugriff sperren
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-body-1 mb-3">
                      Du kannst den Zugriff unabhängig von den Berechtigungen
                      für diesen Benutzer temporär sperren ohne diesen
                      unwiderruflich aus der Organisation zu entfernen.
                    </div>
                    <v-btn color="warning" depressed @click="test()" disabled>
                      <v-icon left>mdi-shield-lock</v-icon>
                      Zugriff sperren
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
              <div class="mt-7">
                <v-card>
                  <v-card-title>
                    <div class="d-flex align-center">
                      <v-icon left color="error">mdi-delete</v-icon>
                      <div class="subtitle-1 font-weight-medium">
                        Mitgliedschaft entfernen
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-body-1 mb-3">
                      Beim Entfernen der Mitgliedschaft eines Benutzers verliert
                      dieser alle Berechtigungen für diese Organisation.
                      Bestehende Daten in Verbindung mit dem Nutzer werden
                      zunächst archiviert und nach Ablauf der
                      Aufbewahrungsfristen gelöscht.
                    </div>
                    <v-alert type="warning" text dense class="mb-3">
                      <strong>Achtung:</strong> Diese Aktion kann nicht
                      rückgängig gemacht werden.
                    </v-alert>
                    <v-btn
                      color="error"
                      depressed
                      :loading="loading"
                      @click="toggleConfirmationDialog()"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Mitgliedschaft entfernen
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-wrench-outline"
                title="Support-Aktionen"
              ></Subheader>
              <div class="mt-7">
                <v-card>
                  <v-card-title>
                    <div class="d-flex align-center">
                      <v-icon left color="primary">mdi-key-plus</v-icon>
                      <div class="subtitle-1 font-weight-medium">
                        Lizenz hinzufügen
                      </div>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-body-1 mb-3">
                      Füge diesem Benutzer nachträglich eine Lizenz hinzu. Dies
                      aktualisiert auch das Stripe-Abonnement der Organisation.
                    </div>
                    <v-btn
                      color="primary"
                      depressed
                      @click="toggleAddLicenseDialog()"
                    >
                      <v-icon left>mdi-key-plus</v-icon>
                      Lizenz hinzufügen
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
    <CustomDialog
      v-if="confirmationDialog.model"
      @close="toggleConfirmationDialog()"
      title="Mitgliedschaft entfernen"
      text="Bist Du sicher, dass Du diese Mitgliedschaft entfernen möchtest?"
      :loading="confirmationDialog.loading"
      :btnAction="deleteMembership"
      btnColor="error"
      width="s"
    ></CustomDialog>
    <v-dialog v-model="addLicenseDialog.model" max-width="600" persistent>
      <v-card>
        <v-card-title>
          <v-icon left color="primary">mdi-key-plus</v-icon>
          Lizenz hinzufügen
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="addLicenseDialog.selectedProduct"
                  :items="products"
                  item-text="title"
                  item-value="id"
                  item-key="id"
                  return-object
                  :hint="
                    addLicenseDialog.selectedProduct &&
                    addLicenseDialog.selectedProduct.price
                      ? formatPrice(addLicenseDialog.selectedProduct.price)
                      : 'Bitte wählen Sie eine Lizenz aus'
                  "
                  required
                  persistent-hint
                  outlined
                  dense
                  prepend-inner-icon="mdi-key-variant"
                  label="Lizenz"
                >
                  <template v-slot:item="{ item }">
                    <div>
                      <div>{{ item.title }}</div>
                      <div
                        class="text-caption text--secondary"
                        v-if="item.price"
                      >
                        {{ formatPrice(item.price) }}
                      </div>
                    </div>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="addLicenseDialog.licenseName"
                  label="Lizenz-Name (optional)"
                  outlined
                  dense
                  prepend-inner-icon="mdi-text"
                  hint="Optional: Name für die Lizenz"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="addLicenseDialog.updateStripeSubscription"
                  label="Stripe-Abonnement aktualisieren"
                  hint="Wenn aktiviert, wird das Stripe-Abonnement automatisch aktualisiert"
                  persistent-hint
                  class="mt-0"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-alert type="info" text dense>
                  Diese Aktion fügt dem Benutzer eine neue Lizenz hinzu und
                  aktualisiert das Stripe-Abonnement der Organisation.
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="toggleAddLicenseDialog()"
            :disabled="addLicenseDialog.loading"
          >
            Abbrechen
          </v-btn>
          <v-btn
            color="primary"
            depressed
            :loading="addLicenseDialog.loading"
            @click="addLicenseToUser()"
            :disabled="!addLicenseDialog.selectedProduct"
          >
            <v-icon left>mdi-key-plus</v-icon>
            Lizenz hinzufügen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view />
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
import { ADMIN } from "@/store/modules.js";
import { GET_ROLES, UPDATE_MEMBERSHIP_ROLE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import PermissionTreeView from "@/components/_systemwide/PermissionTreeView.vue";

export default {
  name: "admin-users-tab-accounts-account-details",
  components: {
    NavigationBar,
    CustomDialog,
    Subheader,
    SupportTools,
    PermissionTreeView,
  },
  data() {
    return {
      snackbar: { text: "", model: false },
      data: {
        user: {
          displayName: "",
          uid: "",
          email: "",
        },
        group: {
          title: "",
          id: "",
        },
        division: null,
        license: null,
        access: {
          status: "",
          type: "",
          disabled: false,
          featureFlags: [],
          roles: {
            groupRolesIds: [],
            individualRolesIds: [],
          },
          permissions: {
            allPermissionsIds: [],
            groupPermissionsIds: [],
            individualPermissionsIds: [],
          },
        },
      },
      confirmationDialog: {
        model: false,
        loading: false,
      },
      addLicenseDialog: {
        model: false,
        loading: false,
        selectedProduct: null,
        licenseName: "",
        updateStripeSubscription: true,
      },
      loading: false,
      products: [],
      // teams: [],
    };
  },
  computed: {
    roles() {
      return this.$store.state.admin.roles;
    },
    checkIfSupport() {
      return this.$store.getters["user/checkIfSupport"];
    },
    code() {
      return [{ title: "account", data: this.data }];
    },
    allPermissions() {
      return this.data?.access?.permissions?.allPermissionsIds || [];
    },
    groupPermissions() {
      return this.data?.access?.permissions?.groupPermissionsIds || [];
    },
    individualPermissions() {
      return this.data?.access?.permissions?.individualPermissionsIds || [];
    },
    rolePermissions() {
      // Role permissions = all - group - individual
      const all = this.allPermissions;
      const group = this.groupPermissions;
      const individual = this.individualPermissions;
      return all.filter((p) => !group.includes(p) && !individual.includes(p));
    },
    filteredGroupRolesIds() {
      return (this.data?.access?.roles?.groupRolesIds || []).filter(
        (roleId) => !this.isInternalUserRole(roleId),
      );
    },
  },
  created() {
    this.initialize();
    this.getProducts();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ADMIN}${GET_ROLES}`, {
        organizationId: this.$route.params.organizationId,
      });

      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("membershipsPrivate")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.data = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    updateRole() {
      this.$store
        .dispatch(`${ADMIN}${UPDATE_MEMBERSHIP_ROLE}`, {
          organizationId: this.$route.params.organizationId,
          itemId: this.$route.params.itemId,

          roles: this.data.access.roles.individualRolesIds,
        })
        .then(() => {
          this.snackbar.text = "Berechtigungen aktualisiert";
          this.snackbar.model = true;
        })
        .catch((error) => {
          console.log(error);
          this.snackbar.text = error.message;
          this.snackbar.model = true;
        });
    },
    routeDetails(item) {
      this.$router.push({
        name: "my-organization-team-details",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item,
        },
      });
    },
    textFromUserStatus(item) {
      switch (item) {
        case "activated":
          return "Zugang aktiv";
        case "deactivated":
          return "Zugang deaktiviert";
        default:
          return "";
      }
    },
    getRoleTitle(roleId) {
      const role = this.roles.find(
        (r) => r.meta?.id === roleId || r.id === roleId,
      );
      return role?.title || roleId;
    },
    isInternalUserRole(roleId) {
      const role = this.roles.find(
        (r) => r.meta?.id === roleId || r.id === roleId,
      );
      // Filter out roles that are marked as internal or are "user" type roles for Firestore triggers
      return (
        role?.meta?.internal === true ||
        role?.type === "user" ||
        roleId === "user"
      );
    },
    initialien(fullName) {
      const namesArray = fullName.trim().split(" ");
      if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`;
      else
        return `${namesArray[0].charAt(0)}${namesArray[
          namesArray.length - 1
        ].charAt(0)}`;
    },
    toggleConfirmationDialog() {
      this.confirmationDialog.model = !this.confirmationDialog.model;
    },
    toggleAddLicenseDialog() {
      this.addLicenseDialog.model = !this.addLicenseDialog.model;
      if (!this.addLicenseDialog.model) {
        // Reset form when closing
        this.addLicenseDialog.selectedProduct = null;
        this.addLicenseDialog.licenseName = "";
        this.addLicenseDialog.updateStripeSubscription = true;
      }
    },
    getProducts() {
      db.collection("products")
        .where("active", "==", true)
        .where("userVisible", "==", true)
        .where("userSelectable", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();

            let priceInfo = null;
            if (data.prices && Array.isArray(data.prices)) {
              const recurringPrice = data.prices.find(
                (p) =>
                  p.active &&
                  p.visibleToUsers === true &&
                  p.recurring &&
                  p.recurring.interval === "month",
              );
              if (recurringPrice) {
                priceInfo = {
                  amount: recurringPrice.unitAmount,
                  currency: recurringPrice.currency,
                  interval: recurringPrice.recurring.interval,
                };
              }
            }

            this.products.push({
              title: data.name,
              id: doc.id,
              isDefault: data.isDefault || false,
              price: priceInfo,
            });
          });
        });
    },
    formatPrice(priceInfo) {
      if (
        !priceInfo ||
        priceInfo.amount === null ||
        priceInfo.amount === undefined
      )
        return "";
      const amount = (priceInfo.amount / 100).toFixed(2).replace(".", ",");
      const currency =
        priceInfo.currency === "eur" ? "€" : priceInfo.currency.toUpperCase();

      const intervalMap = {
        day: "Tag",
        week: "Woche",
        month: "Monat",
        year: "Jahr",
      };
      const interval = intervalMap[priceInfo.interval] || priceInfo.interval;

      return `${currency}${amount} / ${interval}`;
    },
    addLicenseToUser() {
      this.addLicenseDialog.loading = true;
      const callFunction = functions.httpsCallable(
        "stripeBilling-createLicenses",
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        licenses: [
          {
            userId: this.$route.params.itemId,
            productId: this.addLicenseDialog.selectedProduct.id,
            licenseName:
              this.addLicenseDialog.licenseName ||
              this.addLicenseDialog.selectedProduct.title ||
              null,
          },
        ],
        updateStripeSubscription:
          this.addLicenseDialog.updateStripeSubscription,
      })
        .then((result) => {
          if (result.data.success && result.data.results.length > 0) {
            this.snackbar.text = `Lizenz erfolgreich hinzugefügt (ID: ${result.data.results[0].licenseId})`;
            this.snackbar.model = true;
            this.toggleAddLicenseDialog();
            this.initialize(); // Refresh data
          } else {
            const errorMsg =
              result.data.errors.length > 0
                ? result.data.errors[0].error
                : "Fehler beim Hinzufügen der Lizenz";
            this.snackbar.text = errorMsg;
            this.snackbar.model = true;
          }
          this.addLicenseDialog.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.snackbar.text = `Fehler: ${err.message}`;
          this.snackbar.model = true;
          this.addLicenseDialog.loading = false;
        });
    },
    deleteMembership() {
      this.confirmationDialog.loading = true;
      const callFunction = functions.httpsCallable(
        "organization-deleteMembership",
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        userId: this.$route.params.itemId,
      })
        .then((result) => {
          if (result.data.success) {
            // this.showSuccess = true;
            this.confirmationDialog.model = false;
            this.confirmationDialog.loading = false;
            // this.snackbar = true;
            this.$router.push({
              name: "admin-users-tab-accounts",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          } else {
            this.errorMsg = "Fehler";
            this.confirmationDialog.loading = false;
          }
        })
        .catch((err) => {
          // handle error
          console.error(err);
          // this.errorMsg = err.message;
          this.confirmationDialog.loading = false;
        });
    },
  },
};
</script>
